
import React from 'react';
import TrackItem from './SortableTrackItem';
import { FeaturedTrack } from '@/hooks/useFeaturedTracks';

interface TracksListProps {
  tracks: FeaturedTrack[];
  onDelete: (trackId: string) => void;
  onReorder: (tracks: FeaturedTrack[]) => void;
}

const TracksList: React.FC<TracksListProps> = ({ tracks, onDelete }) => {
  return (
    <div className="tracks-list">
      <p className="text-sm text-muted-foreground mb-4">
        These tracks will be displayed on the homepage.
      </p>
      
      {tracks.map(track => (
        <TrackItem 
          key={track.id} 
          track={track} 
          onDelete={onDelete} 
        />
      ))}
    </div>
  );
};

export default TracksList;
